import React from 'react'
import {
  AUDIT_RESULT,
  ControlTest,
  OeTestStatus,
} from '@trustero/trustero-api-web/lib/audit/auditbot_pb'
import { GapType } from '@trustero/trustero-api-web/lib/artifact/artifact_pb'

export type AuditBotControlChecksType = {
  controlId: string
  modelId: string
  name: string
  checks: ControlTest[]
  isNotApplicable?: boolean
  // Live per-procedure OE status for a control still processing (no final
  // ControlTest rows yet). Empty/absent once the control completes — the
  // `checks` rows carry the result then.
  liveStatuses?: OeTestStatus[]
}

interface ControlResultCountConfig {
  count: number
  text: string
  key?: AUDIT_RESULT
}

export type ControlResultCountsType = {
  [AUDIT_RESULT.PASS]: ControlResultCountConfig
  [AUDIT_RESULT.FAIL]: ControlResultCountConfig
  [AUDIT_RESULT.NOT_APPLICABLE]: ControlResultCountConfig
  [AUDIT_RESULT.UNKNOWN]: ControlResultCountConfig
  [AUDIT_RESULT.MISSING_SUGGESTIONS]: ControlResultCountConfig
} & { SUCCESSFUL: ControlResultCountConfig }

// TODO: Move this enum to Ntrced side to ensure we always use the proper values and avoid duplicate enums/constants
export enum CONTROL_TEST_NAMES {
  POLICY_MATCH = 'Control-Policy Material Difference',
  COMPLETENESS = 'Evidence Completeness',
  ONBOARDING = 'Onboarding',
  OFFBOARDING = 'Offboarding',
  ONGOING_EMPLOYEES = 'Ongoing Employees',
  SPOT_CHECK = 'Operating Effectiveness Check',
}

export const DEFAULT_TEST_NAMES: CONTROL_TEST_NAMES[] = [
  CONTROL_TEST_NAMES.SPOT_CHECK,
]

export const GAP_TYPE_TO_LABEL = {
  [GapType.MISSING_EVIDENCE]: 'Missing Evidence',
  [GapType.INCOMPLETE_EVIDENCE]: 'Incomplete Evidence',
  [GapType.FINDING_IN_EVIDENCE_PROVIDED]: 'Finding in Evidence',
  [GapType.OUTDATED_EVIDENCE]: 'Outdated Evidence',
}

export const PASSED_CONTROL_CHECK_TEXT = Object.freeze({
  [CONTROL_TEST_NAMES.POLICY_MATCH]:
    'Do the control objective and the parent policy align or are there material differences?',
  [CONTROL_TEST_NAMES.COMPLETENESS]: (
    <span>
      Does this control appear to have all <em>required evidence</em> attached
      to it?
    </span>
  ),
  [CONTROL_TEST_NAMES.ONBOARDING]:
    'Control requirements fulfilled for all new employees during this period',
  [CONTROL_TEST_NAMES.OFFBOARDING]:
    'Offboarded employees track across control requirement',
  [CONTROL_TEST_NAMES.ONGOING_EMPLOYEES]:
    'Employee list matches control requirement',
  [CONTROL_TEST_NAMES.SPOT_CHECK]: (
    <span>
      Does the attached evidence pass the <em>test procedures?</em>
    </span>
  ),
})

export const EMPTY_EVIDENCE_REASON = 'Cannot build the table from data content'
export const NO_TEST_TABLE_REASON =
  'The evidence was not classified as a test table with confidence'
